const groupPrefix = createApiRoute(
	ApiModule.PRODUCTION_PLANNING,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.PRODUCTION_SOCKETS,
)

export const apiProductionSockets = {
	fetchProductionSockets: async (): Promise<IApiResponseModel<IProductionSocketModel[]>> => {
		const { data, meta } = await apiCommon<IProductionSocket[]>(`${groupPrefix}/not-added`, {
			method: 'GET',
		})

		return { data: data.map(d => ProductionSocket(d)), meta }
	},

	fetchAddedProductionSockets: async (): Promise<IApiResponseModel<IProductionSocketModel[]>> => {
		const { data, meta } = await apiCommon<IProductionSocket[]>(`${groupPrefix}`, {
			method: 'GET',
		})

		return { data: data.map(d => ProductionSocket(d)), meta }
	},

	fetchProductionSocketByID: async (id: number): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return { data: ProductionSocket(data), meta }
	},

	addProductionSocket: async (
		socketID: number,
		payload: IProductionSocketCreatePayload,
	): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}/${socketID}`, {
			method: 'POST',
			body: payload,
		})

		return { data: ProductionSocket(data), meta }
	},

	updateProductionSocket: async (
		socketID: number,
		payload: IProductionSocketUpdatePayload,
	): Promise<IApiResponseModel<IProductionSocketModel>> => {
		const { data, meta } = await apiCommon<IProductionSocket>(`${groupPrefix}/${socketID}`, {
			method: 'PUT',
			body: payload,
		})

		return { data: ProductionSocket(data), meta }
	},

	fetchBasicProductionMachines: async (): Promise<IApiResponseModel<IProductionSocketStageMachineModel[]>> => {
		const { data } = await apiCommon<IProductionSocketStageMachine[]>(`${groupPrefix}/machines`, {
			method: 'GET',
		})

		return { data }
	},

	fetchSocketMachineTypes: async (
		socketID: number,
	): Promise<IApiResponseModel<IProductionSocketBasicMachineTypeModel[]>> => {
		const { data } = await apiCommon<IProductionSocketBasicMachineType[]>(
			`${groupPrefix}/${socketID}/machine-types`,
			{
				method: 'GET',
			},
		)

		return { data: data.map(ProductionSocketBasicMachineType) }
	},
}
